import type { CSSProperties } from "react";
import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

export function CoupleSection({ data, config, copy }: SectionRenderProps) {
  const introImage = resolveAssetPath(String(config.settings.introBackground || data.invitation.coverImage));
  const style = { "--photo": `url("${introImage}")` } as CSSProperties;
  return (
    <>
      <section className="intro band intro-photo-bg" style={style}>
        <div className="section-inner intro-grid">
          <div>
            <p className="eyebrow">Dear Family & Friends</p>
            <h2 data-editor-section="couple" data-editor-field="invitation.openingText">{data.invitation.openingText}</h2>
          </div>
          <p className="intro-text">{copy.dear} {data.invitation.guestName}, {data.invitation.closingText}</p>
        </div>
      </section>
      <section className="couple section-inner" id="couple">
        {([data.couple.groom, data.couple.bride] as const).map((person, index) => (
          <article className="profile" key={index === 0 ? "groom" : "bride"}>
            <img src={resolveAssetPath(person.photo)} alt={person.fullName} data-editor-section="couple" data-editor-field={`couple.${index === 0 ? "groom" : "bride"}.photo`} />
            <div>
              <p className="eyebrow">{index === 0 ? copy.groom : copy.bride}</p>
              <h2 data-editor-section="couple" data-editor-field={`couple.${index === 0 ? "groom" : "bride"}.displayName`}>{person.displayName}</h2>
              {person.parents ? <p data-editor-section="couple" data-editor-field={`couple.${index === 0 ? "groom" : "bride"}.parents`}>{person.parents}</p> : null}
              {person.instagram ? <a href={person.instagram} target="_blank" rel="noreferrer">Instagram</a> : null}
            </div>
          </article>
        ))}
      </section>
    </>
  );
}
